/* import __COLOCATED_TEMPLATE__ from './account-history-table.hbs'; */
import Component from '@glimmer/component';
import styles from './account-history-table.module.scss';

export default class SiteBillingAccountHistoryTable extends Component {
  styles = styles;
}
